import React from 'react';
import './BoardClickUpFilterChip.css';

/**
 * Botão compacto estilo ClickUp para a toolbar direita do Board.
 */
export function BoardClickUpToolbarButton({
  label,
  icon: Icon,
  iconOnly = false,
  onClick,
  onMouseDown,
  disabled = false,
  isLoading = false,
  isOpen = false,
  ariaLabel,
  tooltip,
  className = '',
  iconClassName = '',
  children,
}) {
  const showLabel = !iconOnly && label;

  return (
    <div className="board-clickup-icon-btn-anchor">
      <button
        type="button"
        className={[
          'board-clickup-filter-chip',
          iconOnly ? 'board-clickup-filter-chip--icon-only' : '',
          isLoading ? 'is-loading' : '',
          isOpen ? 'is-open' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onClick}
        onMouseDown={onMouseDown}
        disabled={disabled}
        aria-label={ariaLabel || label}
        aria-expanded={isOpen || undefined}
      >
        {Icon ? (
          <span className="board-clickup-filter-chip-icon" aria-hidden="true">
            <Icon
              size={13}
              strokeWidth={1.75}
              className={[isLoading ? 'board-clickup-icon-btn-spin' : '', iconClassName]
                .filter(Boolean)
                .join(' ')}
            />
          </span>
        ) : null}
        {showLabel ? (
          <span className="board-clickup-filter-chip-text">
            <span className="board-clickup-filter-chip-label">{label}</span>
          </span>
        ) : null}
        {children}
      </button>
      {tooltip && !isOpen ? (
        <span className="board-clickup-tooltip board-clickup-tooltip--bottom" role="tooltip">
          {tooltip}
        </span>
      ) : null}
    </div>
  );
}
